import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Images } from "lucide-react";
import { api } from "../lib/api";
import SectionHeading from "./SectionHeading";

const API_BASE = process.env.REACT_APP_BACKEND_URL;

export default function GallerySection() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api("/gallery")
      .then((d) => setItems(d.slice(0, 8)))
      .catch(() => {});
  }, []);

  if (items.length === 0) return null;

  return (
    <section id="gallery" className="relative py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <SectionHeading
          eyebrow="Gallery"
          title="Straight From The Trenches"
          sub="Unfiltered client wins — transformations, check-ins and results in the wild."
        />
        <div className="mt-12 columns-2 md:columns-3 lg:columns-4 gap-4 [column-fill:_balance]">
          {items.map((item, i) => (
            <motion.div
              key={item.id}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.05 }}
              transition={{ duration: 0.5, delay: (i % 4) * 0.06 }}
              className="group relative mb-4 break-inside-avoid overflow-hidden rounded-2xl border border-line bg-panel"
              data-testid={`gallery-highlight-${i}`}
            >
              <img
                src={`${API_BASE}${item.url}`}
                alt="Client transformation highlight"
                className="w-full transition-transform duration-500 group-hover:scale-[1.04]"
                loading="lazy"
              />
              <span className="absolute inset-0 bg-gradient-to-t from-ink/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            </motion.div>
          ))}
        </div>
        <div className="mt-10 text-center">
          <Link
            to="/gallery"
            data-testid="gallery-view-all-btn"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full border border-accent/50 text-emerald-300 font-extrabold uppercase tracking-wide transition-all duration-300 hover:bg-accent hover:text-ink hover:shadow-glow-emerald"
          >
            <Images className="h-4 w-4" />
            View Full Gallery
            <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}